import { render, staticRenderFns } from "./RelateLocations.vue?vue&type=template&id=3d97b07e&"
import script from "./RelateLocations.vue?vue&type=script&lang=js&"
export * from "./RelateLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports